// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3cN-H","container":"styles_container__2MLfV","title":"styles_title__sHlgP","wrapper":"styles_wrapper__35af_","answer":"styles_answer__3tjfi"};